import { ACTIONS } from 'tracker.constants';

const initialState = {
  hasFinishedScreenFlow: false
};

export default function finishedScreenFlow(state = initialState, action) {
  const nextState = { ...state };
  if (action.type === ACTIONS.SAVE_HAS_FINISHED_SCREEN_FLOW) {
    nextState.hasFinishedScreenFlow = action.hasFinishedScreenFlow;
  }
  return nextState;
}
